import React, { useRef, useState } from "react";
import { compressImage } from "./photo";

// One optional photo: picked from the camera or gallery (the browser's native
// picker sheet via <input type="file" accept="image/*">, no extra permissions
// or plugin needed), compressed on the device, then handed up as a data URL.
// Shared by the task form (reference photo) and the submit sheet (proof photo).
const PhotoField = ({ tokens, label, value, onChange, disabled }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const pick = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; // so picking the same file again still fires onChange
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      onChange(await compressImage(file));
    } catch (err) {
      setError(err.message || "Could not process that image.");
    }
    setBusy(false);
  };

  const btn = {
    padding: "10px 14px",
    borderRadius: 10,
    border: `1px solid ${tokens.surfaceBorder}`,
    background: "none",
    color: tokens.textPrimary,
    fontSize: 13,
    fontWeight: 700,
    cursor: disabled || busy ? "default" : "pointer",
    opacity: disabled ? 0.6 : 1,
  };

  return (
    <div style={{ marginBottom: 14 }}>
      {label && <div style={{ marginBottom: 6, fontSize: 12, fontWeight: 600, color: tokens.textMuted }}>{label}</div>}
      <input ref={inputRef} type="file" accept="image/*" onChange={pick} style={{ display: "none" }} disabled={disabled} />
      {value ? (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src={value} alt="" style={{ width: 64, height: 64, borderRadius: 10, objectFit: "cover", border: `1px solid ${tokens.surfaceBorder}` }} />
          <div style={{ display: "flex", gap: 8 }}>
            <button type="button" style={btn} onClick={() => inputRef.current.click()} disabled={disabled || busy}>Change</button>
            <button type="button" style={{ ...btn, color: tokens.negative, borderColor: tokens.negative }} onClick={() => onChange(null)} disabled={disabled}>Remove</button>
          </div>
        </div>
      ) : (
        <button type="button" style={btn} onClick={() => inputRef.current.click()} disabled={disabled || busy}>
          {busy ? "Processing…" : "+ Add a photo"}
        </button>
      )}
      {error && <div role="alert" style={{ marginTop: 6, fontSize: 12, color: tokens.negative }}>{error}</div>}
    </div>
  );
};

export default PhotoField;
